<template>
  <div class="sx-page page-wrap" :class="'skin-' + sexe">
    <template v-if="!sxi || !sex || !sxy">
      <div class="hd-head">
        <div class="hd-bg">
          <van-image
            class="bg-img"
            v-for="(si, i) in sextArr"
            v-show="sexi == i"
            :title="sexi + '-' + i"
            :key="i"
            :src="shopCos + year + '/top-bg' + i + '.jpg'"
          />
        </div>
      </div>
      <!-- 首页 -->
      <div class="sx-wrap" v-if="!sxi">
        <sx-grid :sexi.sync="sexi"></sx-grid>
      </div>
      <!-- 年份页 -->
      <div class="sx-year" v-else-if="sxi && (!sex || !sxy)">
        <sx-year :sxi="sxi"></sx-year>
        <div class="pd-t" style="color: #999">
          当前为【{{ sext }}】命生肖【{{ sxt }}】
        </div>
        <div class="pd-t flex-x fe-c">
          <van-button
            type="info"
            icon="apps-o"
            class="mg-r"
            @click="openUrl('/sx')"
            >切换生肖</van-button
          >
          <van-button
            type="danger"
            icon="exchange"
            @click="openUrl('/sx', { sxi, sex: sex == 1 ? 0 : 1 })"
            >切换男女</van-button
          >
        </div>
      </div>
    </template>

    <!-- 生肖内容页 -->
    <van-skeleton v-else title avatar :row="19" :loading="sxLoad">
      <div class="sx-head pd-t pd-x">
        <h1 class="txt-l mg-0 pd-y">
          {{ this.sxy + '年生肖' + this.sxt + this.sext + '命运程' }}
        </h1>
      </div>
      <van-tabs
        class="sxlm-wrap"
        ref="sxlm"
        v-model="lmTab"
        background="none"
        :border="false"
        @scroll="onScroll"
        title-inactive-color="#FFFFFF"
        title-active-color="#FFFF99"
        scrollspy
        sticky
      >
        <sx-zhibiao @to-lanmu="toLanmu"></sx-zhibiao>

        <!-- 运程栏目遍历 -->
        <van-tab
          v-for="(lm, key) in sxyc"
          :title="lm.title"
          :name="lm.title"
          :key="key"
        >
          <sx-lanmu :lmid="key" :ref="key"></sx-lanmu>
        </van-tab>
      </van-tabs>

      <!-- 浮动工具 -->
      <sx-tools :show="true" />
    </van-skeleton>

    <!-- Footer -->
    <sx-foot></sx-foot>
  </div>
</template>

<script>
import sxTools from '../components/sx-tools'
import sxGrid from '../components/sx-grid'
import sxYear from '../components/sx-year'
import sxLanmu from '../components/sx-lanmu'
import sxZhibiao from '../components/sx-zhibiao'
import sxFoot from '../components/sx-foot'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    sxTools,
    sxGrid,
    sxYear,
    sxLanmu,
    sxZhibiao,
    sxFoot
  },
  data() {
    return {
      sexi: 0,
      loading: true,
      shopCos:
        'https://shop2020-1251134852.cos.ap-guangzhou.myqcloud.com/sxyc/',
      lmTab: '',
      showKit: false
    }
  },
  computed: {
    ...mapState([
      'sxi',
      'sxy',
      'sex',
      'sxyc',
      'year',
      'sextArr',
      'sxLoad',
      'sxYear',
      'askShow'
    ]),
    ...mapGetters(['sexe', 'sext', 'sxt'])
  },
  mounted() {
    this.sexi = this.sex == 1 ? 1 : 0
    if (!this.sxYear) {
      this.$api.loadSxyc()
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    let year = to.path.match(/20\d{2}/g)
    if (year && year[0]) {
      this.$store.commit('setYear', year[0])
    }
    //设置默认
    this.sexi = to.query.sex == 1 ? 1 : 0
    //隐藏生肖选择框
    this.$store.commit('setGridState', false)
    //加载生肖运程
    this.$api.loadSxyc()
    next()
  },
  methods: {
    showDs() {
      this.$store.commit('setDsShow', true)
    },
    onScroll(prm) {
      let offsetTop = 200
      if (prm.scrollTop > offsetTop && !this.showKit) {
        this.showKit = true
      } else if (prm.scrollTop <= offsetTop && this.showKit) {
        this.showKit = false
      }
    },
    toLanmu(e) {
      console.log(e.tit, e.tab)
      this.$refs.sxlm.scrollTo(e.tit)
      if (e.tab) {
        this.$refs.zhibiao[0].$refs.zhibiao.scrollTo(e.tab)
      }
    },
    showGrid(state) {
      this.$store.commit('setGridState', state)
    }
  }
}
</script>

<style lang="scss" scoped>
.sx-wrap {
  position: relative;
}

.sx-year {
  background: #fff;
  margin: 10px;
  padding: 10px 0;
  border-radius: 5px;
}

.hd-bg {
  background-color: #eee;
  background-size: contain;
  background-repeat: no-repeat;
  .bg-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

.hd-bg::after {
  content: '';
  display: block;
  padding-bottom: 77.33%;
}
</style>